<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card border-0" style="background:#ffffff00; border-radius: 15px;">
          <div class="card-body p-3 card-ecc"  v-if="hasECC">
            <div class="row">
              <div class="col-12 text-wrap text-start">
                <p style="font-size:16px; color:white;">Email Compromise Check</p>
              </div>
              <div class="row text-wrap text-default">
                <p class="col-6 text-start" style="font-size:14px; font-weight: 300; ">Last Run:
                  <span  style="font-size:14px; font-weight: 900;">{{lastRun}}</span>
                </p>
                <div class="col-6 text-end p-0">
                  <p style="font-size:14px; font-weight: 300;">Users Checked:
                    <span  style="font-size:14px; font-weight: 900;">{{usersChecked}}</span>
                  </p>
                  <p style="font-size:14px; font-weight: 300;">Impacted Accounts:
                    <span  style="font-size:14px; font-weight: 900;">{{impactedAccounts}}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="row" >
              <div v-if="loading" class="col-md-12 text-center">
                <p style="font-size:14px; padding:20px" class="text-default">Email compromise check is in progress.</p>
              </div>

              <div class="col-12 text-default text-center" v-if="formattedCompromisedAccounts == null || formattedCompromisedAccounts.length == 0 && !loading">
                <div v-if="!loading">
                  <svg width="57" height="50" viewBox="0 0 57 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M30.1829 41.2996C30.1829 40.3634 30.2927 39.4548 30.4299 38.5463H5.4878V11.0132L27.439 24.7797L49.3902 11.0132V25.0275C51.3659 25.3579 53.2043 26.0463 54.878 27.0099V5.50661C54.878 2.47797 52.4085 0 49.3902 0H5.4878C2.46951 0 0 2.47797 0 5.50661V38.5463C0 41.5749 2.46951 44.0529 5.4878 44.0529H30.4299C30.2927 43.1443 30.1829 42.2357 30.1829 41.2996ZM49.3902 5.50661L27.439 19.2731L5.4878 5.50661H49.3902ZM43.2165 50L35.6707 41.7401L38.8537 38.5463L43.2165 42.924L53.0671 33.0396L56.25 36.9218L43.2165 50Z" fill="#00A0C1"/>
                  </svg>
                  <p style="font-size:14px; font-weight:">No accounts have been identified as impacted in a<br>
                    recently disclosed data breach.</p>
                </div>
              </div>
              <div class="col-12 table-responsive" v-if="formattedCompromisedAccounts != null && formattedCompromisedAccounts.length != 0 && !loading">
                <table class="table mb-5 mt-2">
                  <thead v-if="!loading">
                    <tr class="table-light text-default">
                      <th>Name</th>
                      <th>Email</th>
                      <th># of breaches identified</th>
                    </tr>
                  </thead>
                    <tbody class="align-middle text-default" v-for="(item, index) in formattedCompromisedAccounts" :key="index">
                      <tr @click="setExpandData(item)" data-bs-toggle="collapse" :data-bs-target="'#logs' + index" aria-expanded="false" aria-controls="logs" v-tooltip.top="'Click to show breach details'" style="cursor:pointer;" >
                        <td>{{ item.name }}</td>
                        <td>{{ item.email }}</td>
                        <td>{{ item.breach_count }}</td>
                      </tr>
                      <tr class="collapse collapse-vertical" :id="'logs'+index" style="transition: opacity ease-in-out;">
                        <td colspan="4">
                          <table class="table expand">
                            <thead style="white-space: nowrap;">
                              <tr class="text-default">
                                <th>Company Name</th>
                                <th>Breach Date</th>
                                <th>Compromised Data</th>
                                <th>Breach Summary</th>
                              </tr>
                            </thead>
                            <tbody v-if="!loading" class="text-default">
                              <tr v-for="(item, index) in expandedData.companies" :key="index">
                                <td style="width: 30%; text-align:left;">
                                {{ item.company }}
                                </td>
                                <td  style="width: 30%; text-align:left;">
                                {{ item.breach_date }}
                                </td>
                                <td  style="width: 30%; text-align:left;">
                                {{ item.compromised_data }}
                                </td>
                                <td v-tooltip.top="'Show breach summary'" style="width: 10%; text-align:center;">
                                  <button class="btn btn-default btn-circle" @click="openSummaryDialog(item.summary)">
                                    <i class="fa fa-link"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                            <tbody v-else>
                              <div class="text-center">
                                <div class="spinner-border" role="status">
                                </div>
                              </div>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                </table>
              </div>
<!--
              <div class="col-12 table-responsive" v-if="lastThreeBreach != null && lastThreeBreach.length != 0 && viewHistory && !loading">
                <br/>
                <br/>
                <h6 style="font-size: 16px;" class="text-default">Latest Breach Notifications</h6>
                <table class="table mb-5 mt-2">
                  <thead v-if="!loading">
                    <tr class="table-light text-default">
                      <th>Employee</th>
                      <th>Breach Date</th>
                      <th>Breach Organisation</th>
                      <th>Priority</th>
                      <th>Date Notified</th>
                    </tr>
                  </thead>
                    <tbody class="align-middle text-default" v-for="(item, index) in lastThreeBreach" :key="index">
                      <tr @click="setExpandData(item)" data-bs-toggle="collapse" :data-bs-target="'#logs' + index" aria-expanded="false" aria-controls="logs">
                        <td>{{ item.name }}</td>
                        <td>{{ moment(item.breach_date).format("D MMM YYYY") }}</td>
                        <td>{{ item.company }}</td>
                        <td>{{ checkDataPriority(item.compromised_data) }}</td>
                        <td>{{ moment(item.CreatedAt).local().format("D MMM YYYY")  }}</td>
                      </tr>
                    </tbody>
                </table>
              </div> -->

            </div>
            <div class="row">
              <div class="col-4 d-inline-flex">
                <div class="d-flex p-2" v-tooltip.top="'Alert impacted users to new data breaches'" v-if="!$helper.isVertexAnalyst && $helper.isUserAdmin()|| $helper.settingsAdmin() || $store.state.auth.isSuperAdmin">
                  <div class="form-switch form-check ms-2">
                      <input class="form-check-input" style="cursor:pointer;" id="flexSwitchCheckDefault" type="checkbox" role="switch" v-model="alert" @change="saveOrganisationFeature('update')">
                    </div>
                  <span class="form-check-label text-default" for="flexSwitchCheckDefault" style="cursor:pointer;">
                    <span :class="{  'text-small': vssWidth <= 1065 }" style="white-space: nowrap; font-size: 14px;" >
                      Email Alerts
                    </span>
                  </span>
                </div>
              </div>
              <div class="col-8 text-end p-0 m-0">
                <button type="button" class="btn btn-labeled default btn-sm" v-tooltip.top="'Run a manual check for new data breach alerts'" :class="{  'text-small': vssWidth <= 1065 }"  @mouseover="btnInitiate = 'white'" @mouseleave="btnInitiate= '#00A0C1'" @click="initiateCheck" :disabled="($helper.isVertexAnalyst() && !$helper.settingsAdmin() && !$store.state.auth.isSuperAdmin) || $store.state.auth.isGeneralUser || (!$store.state.auth.isECCAdmin && !$store.state.auth.isSuperAdmin) || loading">
                <span class="btn-label">
                  <svg v-if="!loading" width="16" :height="vssWidth <= 1065 ? 14 :20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.6777 2.56276L8.32869 0.0456472C8.24002 0.0152157 8.12107 0 8.00212 0C7.88317 0 7.76422 0.0152157 7.67554 0.0456472L0.326573 2.56276C0.147066 2.62363 0 2.8323 0 3.02358V13.5094C0 13.7007 0.123276 13.9528 0.272505 14.0724L7.72745 19.9109C7.80314 19.9696 7.90047 20 7.99995 20C8.09944 20 8.19893 19.9696 8.27246 19.9109L15.7274 14.0724C15.8766 13.955 15.9999 13.7029 15.9999 13.5094V3.02358C16.0042 2.8323 15.8572 2.6258 15.6777 2.56276ZM14.4471 13.0921L8.00212 18.1393L1.55717 13.0921V3.79741L8.00212 1.58896L14.4471 3.79741V13.0921ZM5.64257 10.3641L3.96645 12.0487C3.93426 12.0814 3.91619 12.1255 3.91619 12.1715C3.91619 12.2175 3.93426 12.2616 3.96645 12.2943L4.70178 13.0334C4.76883 13.1007 4.87913 13.1007 4.94617 13.0334L6.62229 11.3488C7.82694 12.1117 9.43601 11.9661 10.4849 10.9119C11.7026 9.68808 11.7026 7.70568 10.4849 6.4819C9.26732 5.25812 7.2949 5.25812 6.07728 6.4819C5.02836 7.53614 4.88345 9.15553 5.64257 10.3641ZM7.057 7.46658C7.73394 6.78622 8.83044 6.78622 9.50522 7.46658C10.1822 8.14694 10.1822 9.249 9.50522 9.92718C8.82828 10.6075 7.73177 10.6075 7.057 9.92718C6.38223 9.24682 6.38007 8.14694 7.057 7.46658Z" :fill="btnInitiate"/>
                  </svg>
                  <div v-else class="spinner-border" role="status" style="height:15px; width:15px;">
                   <span class="visually-hidden">Loading...</span>
                  </div>
                </span> <span class="d-none d-sm-inline">Initiate Check</span>
                </button>

                <button type="button" class="btn btn-labeled default btn-sm" v-tooltip.top="'Download ECC Summary'" :class="{ 'text-small': vssWidth <= 1065  }"   @mouseover="btnDownload = 'white'" @mouseleave="btnDownload= '#00A0C1'" @click="download" :disabled="downloading">
                <span class="btn-label">
                  <svg v-if="!downloading" width="17" :height="vssWidth <= 1065 ? 14 : 16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.35682 11.3864C8.37383 11.4081 8.39556 11.4257 8.42036 11.4378C8.44517 11.4498 8.4724 11.4561 8.5 11.4561C8.5276 11.4561 8.55483 11.4498 8.57964 11.4378C8.60444 11.4257 8.62617 11.4081 8.64318 11.3864L11.1886 8.16591C11.2818 8.04773 11.1977 7.87273 11.0455 7.87273H9.36136V0.181818C9.36136 0.0818182 9.27955 0 9.17955 0H7.81591C7.71591 0 7.63409 0.0818182 7.63409 0.181818V7.87045H5.95455C5.80227 7.87045 5.71818 8.04546 5.81136 8.16364L8.35682 11.3864ZM16.8182 10.5909H15.4545C15.3545 10.5909 15.2727 10.6727 15.2727 10.7727V14.2727H1.72727V10.7727C1.72727 10.6727 1.64545 10.5909 1.54545 10.5909H0.181818C0.0818182 10.5909 0 10.6727 0 10.7727V15.2727C0 15.675 0.325 16 0.727273 16H16.2727C16.675 16 17 15.675 17 15.2727V10.7727C17 10.6727 16.9182 10.5909 16.8182 10.5909Z" :fill="btnDownload"/>
                  </svg>
                  <div v-else class="spinner-border" role="status" style="height:15px; width:15px;">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </span> <span class="d-none d-sm-inline">Download</span>
                </button>
              </div>
            </div>
          </div>

          <div class="card-body p-4 card-ecc" v-else >
            <div class="row">
              <div class="col-12 text-wrap text-start">
                <p style="font-size:16px; font-weight: 900; color:white;">Email Compromise Check</p>
              </div>
              <div class="row text-wrap text-default text-center">
                  <h2>
                    No Data Available
                  </h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
    <vue-final-modal v-model="summaryDialog" classes="modal-container" content-class="modal-content">
      <span class="modal__title">Breach Summary</span>
      <div class="modal__content mt-3 mb-4">
        <div>
          <div class="card">
            <div class="card-body">
              <p v-html="summaryData"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal__action">
        <button type="button" class="btn btn-outline-danger" @click="closeSummary">Close</button>
      </div>
    </vue-final-modal>
  </div>


    </div>
   </div>

 </template>

 <script>
	import { VueScreenSizeMixin } from 'vue-screen-size';
  import moment from 'moment';
  import * as XLSX from 'xlsx'

   export default {
    name: 'Dashboard',
    props: ['organisationID', 'isManager', 'showProduct'],
		mixins: [VueScreenSizeMixin],

    setup() {
      return {
        moment: moment,
      };
    },

    data() {
      return {
        summaryDialog: false,
        summaryData: null,
        hasECC: false,
        checking: false,
        alert: true,
        expand: false,
        loading: false,
        headers: [
          { text: "Name", value: "name" },
          { text: "Email", value: "email" },
          { text: "# of breaches identified", value: "breach_count" }
        ],
        compromisedAccounts: [],
        latestCompromisedAccounts: [],
        formattedCompromisedAccounts: [],
        ecc: {},
        eccLatestRun: {},
        btnInitiate: "#00A0C1",
        btnDownload: "#00A0C1",
        expandedData: [],
        vssWidth: 3000,
        shouldHideAlerts: false,
        viewHistory: false,
        lastThreeBreach: {},
        downloading: false,
        impactedAccounts: null,
      };
      },

    async created() {
      if (!this.showProduct) return

      this.init()
      this.vssWidth = this.$vssWidth;
    },

     methods: {

      init(){
        if (this.$store.state.auth.isSuperAdmin || this.$helper.isVertexAnalyst() || this.isManager){
          this.getData()
          this.hasECC = true

          if (this.isManager && this.$store.state.auth.isGeneralUser)  return

          this.checkEnabledFeatures()
        }
        else {
          let products = this.$store.state.user.organisation.products
          products.forEach(v => {
            if (v.product == 'email_compromise_check')
              this.hasECC = true
          });

          if (this.hasECC){
            this.getData()
            this.checkEnabledFeatures()
          }
        }
      },

      setExpandData(item) {
        this.expandedData = item
      },

      setCompromisedAccounts(data) {
        let emails = []
        let compromisedAccounts = data

        data.forEach(value => {

          if ( !emails.includes(value.email) ) {

            let filteredAccounts = this.filterAccountsByEmail(compromisedAccounts, value.email)
            let count = 0

            let tempData = {
              name : value.name,
              email : value.email,
              breach_count: 0,
              companies: []
            }

            for (const account of filteredAccounts) {
              count++
              tempData.companies.push({
                company: account.company,
                breach_date: account.breach_date,
                compromised_data: account.compromised_data,
                summary: account.description,
              })
            }

            tempData.breach_count = count

            this.formattedCompromisedAccounts.push(tempData)
            emails.push(value.email)
          }
        });

        if (this.isManager) {
          this.impactedAccounts = emails.length
        }

      },

      filterAccountsByEmail(array, email) {
        return array.filter((value) => {
              return value.email == email
            });
      },

      async getData() {
        await this.getLastRun()

        if (this.ecc != null)
          await this.getLatestCompromisedAccounts(this.ecc.ID)
      },

      async getLastRun() {
        let params = {};

        if (this.isManager)  params.manager = this.isManager;

        try {
          const response = await this.$axios.get(`/orgadmin/email-compromise-check/organisations/${this.organisationID}/last-run`, {params});

          if (response.data.success) {
              this.ecc = response.data.email_compromise_check;
              this.eccLatestRun = response.data.email_compromise_check;
            }
        } catch (error) {
          // Handle error
        }
      },

      async getCompromisedAccounts() {
        let params = {};

        if (this.isManager)  params.manager = this.isManager;
        await this.$axios.get(`/orgadmin/email-compromise-check/organisations/${this.organisationID}/compromised-account`,{params})
          .then(  response => {
            this.compromisedAccounts = response.data.compromised_accounts
          })
          .catch()
      },

      async getLatestCompromisedAccounts(id) {
        let params = {};

        if (this.isManager)  params.manager = this.isManager;

        await this.$axios.get(`/orgadmin/email-compromise-check/organisations/${this.organisationID}/compromised-account/${id}`,{params})

          .then(  response => {
            this.latestCompromisedAccounts = response.data.compromised_accounts
            this.lastThreeBreach = this.sortLatest(this.latestCompromisedAccounts)
            this.setCompromisedAccounts(response.data.compromised_accounts)
            this.tableLoading = false
          })
          .catch()
      },

      sortLatest(accounts) {
        // Convert the object to an array for easier sorting
        const accountsArray = Object.values(accounts);

        // Sort the array by 'CreatedAt' in descending order using 'moment' for date comparison
        const sortedArray = accountsArray.sort((a, b) => {
          return moment(b.CreatedAt).diff(moment(a.CreatedAt));
        });

        // Get the latest 3 items
        return sortedArray.slice(0, 3);
      },

      async initiateCheck() {
        this.loading = true
        this.formattedCompromisedAccounts = []

        let data = await this.$axios.get(`/orgadmin/email-compromise-check/organisations/${this.organisationID}/check-pawned-accounts`)
          .then(  response => {
              if (response.data.success) {
                return response.data.ecc
              } else {
                this.$toast.error(response.data.message)
                this.loading = false
                return 0
              }
          })
          .catch(() => {
            this.loading = false
            return 0
          })

        // get last run
        await this.getLastRun()

        // get data after initiating a check
        if (data.ecc_id > 0) {
          await this.getLatestCompromisedAccounts(data.ecc_id)
          this.viewHistory = false;
        }

        this.loading = false;
        this.btnInitiate = '#00A0C1';
      },

      async getOrganisationFeatures() {
      let data = await this.$axios.get(`/orgadmin/organisations/${this.organisationID}/organisation-feature`)
          .then((response) => {
              if (response.data.success){
                  return response.data.org_features
              } else {
                  this.$toast.error(response.data.message)
                  return null
              }
          })
          .catch()

          return data
      },

      saveOrganisationFeature(state){
        let data = {
            organisation_id: this.organisationID,
            email_compromise_check: this.alert,
        }

        if ( state == 'save') {
          this.$axios.post(`/orgadmin/organisations/`+ this.organisationID +`/organisation-feature`, data)
          .catch();
          } else {
            this.$axios.put(`/orgadmin/organisations/`+ this.organisationID +`/organisation-feature`, data)
            .then((response) => {
              if (!response.data.success)
                  this.$toast.success(response.data.message)
              if (this.alert)
                this.$toast.success('Email Compromise alerts have been enabled for all users in your organisation.')
              else
                this.$toast.success('Email Compromise alerts have been disabled for all users in your organisation.')
              })
            .catch()
        }
      },

      async checkEnabledFeatures() {
        const orgFeatures = await this.getOrganisationFeatures();

        if ( orgFeatures == null || orgFeatures.length < 1 ) {
            this.saveOrganisationFeature('save')
        } else {
          if (orgFeatures[0].email_compromise_check == null) {
            this.saveOrganisationFeature('update')
            return
          }
          this.alert = orgFeatures[0].email_compromise_check
        }
      },

      async download() {
        //set download state
        this.downloading = true;
        await this.getCompromisedAccounts()

        if (this.compromisedAccounts.length == 0){
          this.$toast.error('No compromised accounts to download.')
          this.downloading = false;
          return
        }

        var dateToday = moment().format("YYYYMMD")

        let data = await this.prepareData();

        const ws = XLSX.utils.aoa_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
        /* generate file and send to client */
        XLSX.writeFile(wb, dateToday + "_" + this.formattedOrgName + "_Email_Compromise_Check_Report.xlsx");

        //remove download state
        this.downloading = false;
        this.btnDownload = '#00A0C1';
      },

      async prepareData() {
        let rows = [["Employee Name", "Email", "Breach Date", "Breach Organisation", "Priority", "Compromised Data", "Breach Summary", "Date Notified of Breach",]];
        for (const account of this.compromisedAccounts) {
          rows.push([
            account.name,
            account.email,
            account.breach_date,
            account.company,
            this.checkDataPriority(account.compromised_data),
            account.compromised_data,
            account.description,
            moment(account.CreatedAt).local().format("h:mma D MMM YYYY")
          ]);
        }

        return rows
      },

      closeSummary(){
        this.summaryDialog = false
        this.summaryData =  null
      },

      openSummaryDialog(item){
        this.summaryDialog = true
        this.summaryData =  item
      },

      checkDataPriority(data) {
        const highPriority = ["Auth tokens", "Biometric data", "Credit cards", "Dates of birth", "Driver's licenses", "Encrypted keys", "Government issued IDs", "Passport numbers", "Passwords", "Personal health data", "PINs", "Security questions and answers", "Social security numbers"];
        const mediumPriority = ["Appointments", "Deceased statuses", "Delivery instructions", "Device information", "Device usage tracking data", "Email messages", "Family members' names", "Flights taken", "Job applications", "Licence plates", "Marital statuses", "Mnemonic phrases", "Names", "Partial credit card data", "Partial dates of birth", "Payment methods", "Phone numbers", "Physical addresses", "Places of birth", "Spouses names", "Usernames", "Vehicle details"];
        const lowPriority = ["Age groups", "Ages", "Avatars", "Bios", "Browser user agent details", "Eating habits", "Education levels", "Email addresses", "Employers", "Employment statuses", "Ethnicities", "Family structure", "Genders", "Geographic locations", "Home ownership statuses", "Homepage URLs", "Income levels", "Instant messenger identities", "IP addresses", "Job titles", "Living costs", "MAC addresses", "Nationalities", "Occupations", "Partial phone numbers", "Password strengths", "Personal descriptions", "Physical attributes", "Professional skills", "Profile photos", "Religions", "Salutations", "Smoking habits", "Social media profiles", "Spoken languages", "Survey results", "Time zones", "User website URLs", "Website activity", "Years of professional experience", ""];

        const dataArr = data.split(',');

        for (let i = 0; i < highPriority.length; i++) {
          if (dataArr.includes(highPriority[i])) {
            return "High";
          }
        }

        for (let i = 0; i < mediumPriority.length; i++) {
          if (dataArr.includes(mediumPriority[i])) {
            return "Medium";
          }
        }

        for (let i = 0; i < lowPriority.length; i++) {
          if (dataArr.includes(lowPriority[i])) {
            return "Low";
          }
        }

        return "Unknown";
      },

      updateImpactedAccounts() {
        if (this.eccLatestRun == null) {
          this.impactedAccounts = null;
        } else if (this.eccLatestRun.ID === 0) {
          this.impactedAccounts = "0";
        } else {
          this.impactedAccounts = this.eccLatestRun.impacted_accounts;
        }
      }
    },

    watch: {
      eccLatestRun: {
        handler() {
          this.updateImpactedAccounts();
        },
        immediate: true,
        deep: true
      }
    },

    computed: {
      lastRun() {
        if (this.eccLatestRun == null)
          return null

        return this.eccLatestRun.ID == 0 ? "___________________" : moment(this.eccLatestRun.last_checked).local().format("h:mma D MMM YYYY");
      },

      usersChecked() {
        if (this.eccLatestRun == null)
          return null

        return this.eccLatestRun.ID == 0 ? "0" : this.eccLatestRun.users_checked;
      },

      orgName(){
        return this.$store.state.auth.isSuperAdmin || this.$helper.isVertexAnalyst() ? this.$store.state.user.organisation.name : this.$store.state.user.organisation.organisation
      },

      formattedOrgName() {
      if (this.orgName) {
        if (this.orgName.includes(" ")) {
          // If orgName contains spaces, replace them with underscores
          return this.orgName.replace(/ /g, "_");
        } else {
          // If orgName doesn't contain spaces, keep it as is
          return this.orgName;
        }
      }
      return "";
    },
    },

  }

 </script>
<style>
 .card-ecc {
   border-radius: 15px;
   /* max-width: 584px; */

   background: #00a0c1; /* Old browsers */
     background: -moz-linear-gradient(top,  #00a0c1 0%, #00a0c1 50px, #ffffff 50px); /* FF3.6-15 */
     background: -webkit-linear-gradient(top,  #00a0c1 0%,#00a0c1 50px,#ffffff 50px); /* Chrome10-25,Safari5.1-6 */
     background: linear-gradient(to bottom,  #00a0c1 0%,#00a0c1 50px,#ffffff 50px); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
 }

  /* Gray */
  .default {
    border-color: #00A0C1;
    color: #00A0C1;
    margin:3px;
  }

  .default:hover {
    background: #00A0C1;
    color:white;
  }

  .btn:focus {
    outline: none;
    box-shadow: none;
  }

  .form-check-input:checked {
    background-color: #00A0C1;
    border-color: #00A0C1;
  }

  .btn-labeled:active {
    color: red;
  }

  .text-small{
    font-size: 10px;
  }

</style>
<style scoped>
:deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.modal-content) {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 30%;
}
:deep(.modal-content-monthly) {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 30%;
}

.modal__action {
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 1rem 0 0;
}
</style>